import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface SetPredictiveModelNameParams {
  readonly id: string;
  readonly name: string;
}

export interface SetPredictiveModelNameResult extends IResult {
}

export class SetPredictiveModelNameRequest extends Request<SetPredictiveModelNameParams, SetPredictiveModelNameResult> {
  constructor(params: SetPredictiveModelNameParams) {
    super('setPredictiveModelName', params);
  }
}
